var React = require('react');

function SubArrowIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10 4.99992L6 8.99992L5.05333 8.05325L7.44667 5.66659H0L0 0H1.33333V4.33325H7.44667L5.05333 1.94659L6 0.999919L10 4.99992Z","fill":"#33445E"}));
}

SubArrowIcon.defaultProps = {"width":"10","height":"9","viewBox":"0 0 10 9","fill":"none"};

module.exports = SubArrowIcon;

SubArrowIcon.default = SubArrowIcon;
